import { useMemo, useEffect, useState } from "react"
import { getLeverInfo, Job } from "@/utils/api"

const ALL_TEAMS_KEY = "All Teams"
const ALL_LOCATION_KEY = "All Location"

type Jobs = { [jobID: string]: Job }

export type JobMapByTeam = {
  [ALL_TEAMS_KEY]: string[]
  [department: string]: string[]
}

export type JobMapByLocation = {
  [ALL_LOCATION_KEY]: string[]
  [location: string]: string[]
}
export interface Lever {
  jobs: Jobs
  jobMapByTeam: JobMapByTeam
  jobMapByLocation: JobMapByLocation
  isLoading: boolean
}

const useLever = (): Lever => {
  const [jobData, setJobData] = useState<Job[]>([])
  const [isLoading, setLoading] = useState<boolean>(true)

  useEffect(() => {
    getLeverInfo()
      .then(data => setJobData(data))
      .catch(_ => {
        // reset jobs an empty array
        setJobData([])
      })
      .finally(() => setLoading(false))
  }, [])

  const { jobMapByTeam, jobMapByLocation, jobs } = useMemo(() => {
    return jobData.reduce(
      (prev, current) => {
        const dept = current.categories.department
        const loc = current.categories.location

        if (!dept || !loc) {
          return prev
        }
        prev.jobs[current.id] = current
        //prev.locations[loc] = true

        if (!prev.jobMapByLocation[loc]) {
          prev.jobMapByLocation[loc] = []
        }

        if (!prev.jobMapByTeam[dept]) {
          prev.jobMapByTeam[dept] = []
        }

        prev.jobMapByLocation[loc].push(current.id)
        prev.jobMapByTeam[dept].push(current.id)
        prev.jobMapByLocation[ALL_LOCATION_KEY].push(current.id)
        prev.jobMapByTeam[ALL_TEAMS_KEY].push(current.id)
        return prev
      },
      {
        jobMapByTeam: {
          [ALL_TEAMS_KEY]: [],
        } as JobMapByTeam,
        jobMapByLocation: {
          [ALL_LOCATION_KEY]: [],
        } as JobMapByLocation,
        jobs: {} as Jobs,
      }
    )
  }, [jobData])

  return {
    jobMapByTeam,
    jobMapByLocation,
    jobs,
    isLoading,
  }
}

export default useLever
